// @flow

import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/responsive-utils';

export type ScreenSize = 'small' | 'medium' | 'large' | 'xlarge';

/**
 * Hook to query viewport "size"
 */
export default function useScreenSize(): ScreenSize {
  const { size } = useMediaProps({
    [Screen.queries.phone]: { size: 'small' },
    [Screen.queries.phablet]: { size: 'medium' },
    [Screen.queries.tablet]: { size: 'large' },
    [Screen.queries.desktop]: { size: 'xlarge' },
  });

  return size;
}
